import React, { Component } from 'react';
import { connect } from 'react-redux';

import NRG from './NRG/index.jsx';
import PlaceOrder from './PlaceOrder';
import Charts from './charts'

class MainPage extends Component {
  renderHeadings(){
    let style = {color:'white',padding:0}
    return (
      <div className='row'>
        <div className="col s6" style={{color:'white',padding:0}}>
          <h6 style={{float:'left'}}>Place Order</h6>
        </div>
        <div className="col s6" style={{color:'white',paddingLeft:'0.375rem'}}>
          <h6>Collateral Info</h6>
        </div>
      </div>
    )
  }
  renderPlacement(){
    let background = this.props.orderType == 'BUY' ? 'rgba(100, 173, 97, 0.02)' : 'rgba(222, 114, 113, 0.02)';

    return (
      <div className='row'>
       <div className='col s6' style={{paddingLeft:0,paddingRight:'0.375rem'}}>
         <div className='col s12 section' style={{height:'254px'}}>
           <PlaceOrder/>
         </div>
       </div>
       <div className='col s6' style={{paddingRight:0,paddingLeft:'0.375rem'}}>
         <div className='col s12 section' style={{height:'254px'}}>
           <NRG />
         </div>
       </div>
     </div>
    )
  }
  render() {
    return (
      <div className="col s6" style={{paddingTop:'0px'}}>
         <Charts/>
         {this.renderHeadings()}
         {this.renderPlacement()}
      </div>
		)
  }
}


function mapStateToProps(state,props) {
  return {
    orderType: state.ui_marketplace.orderType
  };
}

export default connect(mapStateToProps, {})(MainPage);
